import { render, staticRenderFns } from "./RiskSurveyOccupation.vue?vue&type=template&id=da3cef70&"
import script from "./RiskSurveyOccupation.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyOccupation.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyOccupation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports